"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepOneOfflineFirstAppointment = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../../atome");
const organisms_1 = require("../../../../organisms");
const User_service_1 = __importDefault(require("../../../../../services/User.service"));
const OfflineFirstAppointment_style_1 = require("../OfflineFirstAppointment.style");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
// @ts-ignore
function StepOneOfflineFirstAppointment({ setCurrentPage, firstAppointmentInfo, setFirstAppointmentInfo, navigation, }) {
    const [locations, setLocations] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const showDetails = (name) => {
        if (locations) {
            const updatedLocations = locations.map((location) => {
                if (location.name === name) {
                    return { ...location, active: true };
                }
                else {
                    return { ...location, active: false };
                }
            });
            setLocations(updatedLocations);
        }
    };
    (0, react_1.useEffect)(() => {
        setLoading(true);
        User_service_1.default.getLocations().then(res => {
            if (res.error) {
                console.log(res.message);
                setLoading(false);
            }
            const locations = res.data.map((location) => ({
                ...location,
                active: 'false',
            }));
            setLocations(locations);
            setLoading(false);
        });
    }, []);
    const next = () => {
        setFirstAppointmentInfo({
            ...firstAppointmentInfo,
            location: locations.filter(loc => loc.active)[0],
        });
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                offlineFirstAppointmentIndex: 2,
            },
        };
        setCurrentPage(reducerType);
    };
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: [OfflineFirstAppointment_style_1.styles.scrollview] },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.marginTop4px },
                    react_1.default.createElement(atome_1.Icon, { icon: "marker" })),
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.header },
                    react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.headerTitle, OfflineFirstAppointment_style_1.styles.greenText] }, "Wo soll Ihr Erstgespr\u00E4ch stattfinden?")),
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.locationsContainer }, locations &&
                    locations.map((location) => (react_1.default.createElement(react_native_1.View, { key: location.name }, location.active !== true ? (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => showDetails(location.name) },
                        react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.locationBox },
                            react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.greenText] }, location.name),
                            react_1.default.createElement(atome_1.Icon, { icon: "chevron", size: 16, color: "#3DB384" })))) : (react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.locationDetails },
                        react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.detailsTitle] }, location.name),
                        react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.flexRow },
                            react_1.default.createElement(atome_1.Icon, { icon: "marker", size: 12, color: "#fff" }),
                            react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.whiteText] }, location.address)),
                        location.openingTimes && (react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.flexRow },
                            react_1.default.createElement(atome_1.Icon, { icon: "clock", size: 12, color: "#fff" }),
                            react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.whiteText] }, location.openingTimes))),
                        react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.flexRow },
                            react_1.default.createElement(atome_1.Icon, { icon: "user", size: 12, color: "#fff" }),
                            react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.whiteText] }, location.doctors)),
                        react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.buttonContainer },
                            react_1.default.createElement(react_native_1.Pressable, { style: OfflineFirstAppointment_style_1.styles.button, onPress: next },
                                react_1.default.createElement(react_native_1.Text, { style: [OfflineFirstAppointment_style_1.styles.buttonText] },
                                    "Termine in ",
                                    location.name)))))))))))));
}
exports.StepOneOfflineFirstAppointment = StepOneOfflineFirstAppointment;
